import React, { useState } from "react";
import { LiaPenSolid } from "react-icons/lia";
import AlertMessage from "../../../components/alert/AlertMessage";
import { ROLE } from "../../../constants/common";
import Container from "../../../shared/Container";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";
import LinedTab from "../../../shared/ui/tab/LinedTab";
import TableComponent from "../../../shared/ui/Table";
import AddUser from "./AddUser";
import UpdatePassword from "./UpdatePassword";

let data = ["Member’s List", "Update Password"];
const columns = ["Name", "Phone", "Role"];

const buildTable = (members) => {
    return members.map((item) => ({
        Name: <P className="text-secondary">{item?.name}</P>,
        Phone: <P className="text-secondary">+{item?.phoneNumber}</P>,
        Role: (
            <div className="flex items-center gap-1">
                <P>
                    {item?.roles.find(
                        (role) => role.name === ROLE.CONSUMER_OWNER
                    )
                        ? "Owner"
                        : "User"}
                </P>
                <LiaPenSolid className="text-xxl text-secondary" />
            </div>
        ),
    }));
};
const MemberDetails = ({ members }) => {
    const [active, setActive] = useState(0);
    const [showMemberDrawer, setShowMemberDrawer] = useState(false);

    return (
        <>
            <div className="border border-blue-60 py-2 px-1.5 rounded-sm">
                <LinedTab
                    className="pb-0 mb-2.4 border-b border-b-blue-200 mt-0 pt-0 "
                    activeClass={"text-blue font-medium duration-300"}
                    inActiveClass={"text-gray-370"}
                    data={data}
                    activeTab={active}
                    onClick={setActive}
                />

                {active === 0 ? (
                    <>
                        {members.length ? (
                            <>
                                <TableComponent
                                    columns={columns}
                                    data={buildTable(members)}
                                    columnClassName="px-0.8 py-1.5"
                                    headerColor="bg-gray-165 "
                                    // oddRowColor="bg-gray-170"
                                    additionalRowClassName="rounded-xl"
                                    borderStyle="border-collapse border border-gray-200"
                                    fontSize="text-xs md:text-sm"
                                />

                                <Button
                                    onClick={() => setShowMemberDrawer(true)}
                                    className="bg-primary w-full rounded-full mt-2 py-0.8 !font-normal"
                                >
                                    Add Member
                                </Button>
                            </>
                        ) : (
                            <AlertMessage
                                message="No members available at the moment or please try adding members to your plant"
                                error
                            />
                        )}
                    </>
                ) : (
                    <>
                        <UpdatePassword />
                    </>
                )}
            </div>

            <BottomDrawer
                isOpen={showMemberDrawer}
                className={"pb-5  "}
                contentClass="bg-white rounded-t-2 "
                onClick={() => setShowMemberDrawer(false)}
            >
                <Container>
                    <AddUser onClick={() => setShowMemberDrawer(false)} />
                </Container>
            </BottomDrawer>
        </>
    );
};

export default MemberDetails;
